<template lang="pug">
  .section-layout
    .content-top
      .section-filter
        .nav-back-btn(@click="goBack")
        .field-group.is-horizontal
          .field
            label.label 起止时间
            .field.is-horizontal
              date-picker.w-140(style="width: 260px;", type="range", placeholder="请选择起止时间", v-model="filter_data.range_time")
          .field
            a.button.primary(@click="search") 搜索
          .field
            a.button(@click="reset") 重置
          .field
            a.button(@click="exportData") 导出
        .time
          .day(:class="date_type === 1 ? 'active' : ''", @click="today") 今日
          .month(:class="date_type === 2 ? 'active' : ''", @click="thisMonth") 本月
    empty-page(v-if="!list.length", :tip="'当前没有员工数据'")
    .content-wrapper.list-wrapper(v-if="list && list.length")
      .table-wrapper
        table.table
          thead
            tr
              td(width="100") 姓名
              td(width="100") 扫码人数
              td(width="100") 扫码次数
              td(width="100") 报名人数
              td(width="100") 领券数量
              td(width="100") 用券数量
              //- td(width="120") 用券金额
              //- td(width="120") 订单实收金额
          tbody(v-if="list.length")
            tr(v-for="(item, index) in list")
              td
                .simple-td(v-text="item.member_name")
              td
                .simple-td(v-text="item.visitor_count")
              td
                .simple-td(v-text="item.visit_count")
              td
                .simple-td(v-text="item.sign_up_count")
              td
                .simple-td(v-text="item.coupon_count")
              td
                .simple-td(v-text="item.coupon_count_used")
              //- td
              //-   .simple-td(v-text="`¥ ${item.coupon_amount_used}`")
              //- td
              //-   .simple-td(v-text="`¥ ${item.coupon_amount_ordered}`")
        .tfoot(v-if="list.length")
          pagination(:pagination-data="pagination_data", @input="paging")
</template>

<script>
import Api from '@/mixins/modules/Content'
import DatePicker from '@/components/generics/form/DatePicker'
import EmptyPage from '@/components/generics/EmptyPage'
import Pagination from '@/components/generics/Pagination'
import ExportApi from '@/mixins/modules/export'
export default {
  name: 'EmployeeData',
  mixins: [Api, ExportApi],
  components: {
    DatePicker,
    EmptyPage,
    Pagination,
  },
  data () {
    return {
      activity_id: '', // 活动id
      date_type: '', // 0选择时间，1今日，2本月,
      // 日期组件
      filter_data: {
        range_time: '',
        start_time: '',
        end_time: '',
      },
      list: [
        // {
        //   "member_name": "张三", // 员工姓名
        //   "visitor_count": 1, // 扫码人数
        //   "visit_count": 3, // 扫码次数
        //   "sign_up_count": 2, // 报名人数
        //   "coupon_count": 3, // 获券数量
        //   "coupon_count_used": 1, // 用券数量
        //   "coupon_amount_used": 2, // 用券金额
        //   "coupon_amount_ordered": 1, // 订单实收金额
        // },
      ],
      pagination_data: {
        current_page: 1,
        per_page: 20,
        last_page: 1,
        total: 0,
      },
      export_start_time: '', // 导出开始时间（调了接口才会变）
      export_end_time: '', // 导出结束时间（调了接口才会变）
    }
  },
  methods: {
    // 返回
    goBack () {
      this.$router.go(-1)
    },

    // 今日
    today () {
      if (this.date_type === 1 || this.date_type === 0) return // 如果已经是今日或搜索状态不请求接口
      this.pagination_data.current_page = 1
      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      const day = new Date().getDate()
      const startTime = new Date(year, month, day)
      const endTime = new Date(year, month, day, 23, 59, 59)
      this.filter_data.start_time = startTime / 1000
      this.filter_data.end_time = endTime / 1000
      this.date_type = 1
      this.filter_data.range_time = ''
      this.getActivityStatisticMember()
    },

    // 本月
    thisMonth () {
      if (this.date_type === 2 || this.date_type === 0) return // 如果已经是本月或搜索状态不请求接口
      this.pagination_data.current_page = 1
      const year = new Date().getFullYear()
      const month = new Date().getMonth()
      const lastDay = new Date(new Date(year, month + 1, 1) - 1).getDate()
      const startTime = new Date(year, month) / 1000
      const endTime = new Date(year, month, lastDay, 23, 59, 59) / 1000
      this.filter_data.start_time = startTime
      this.filter_data.end_time = endTime
      this.date_type = 2
      this.filter_data.range_time = ''
      this.getActivityStatisticMember()
    },

    // 搜索
    search () {
      this.date_type = 0
      this.pagination_data.current_page = 1
      if (this.filter_data.range_time === '') {
        this.filter_data.start_time = ''
        this.filter_data.end_time = ''
      }
      this.getActivityStatisticMember()
    },

    // 重置
    reset () {
      this.date_type = ''
      this.pagination_data.current_page = 1
      this.today()
    },

    /**
     * 分页处理
     * @status  分页的状态
     */
    paging (state) {
      this.pagination_data = state
      this.getActivityStatisticMember()
    },

    // 模板活动员工数据统计
    async getActivityStatisticMember () {
      try {
        const { response, result } = await this.GetActivityStatisticMemberApi({
          activity_id: this.activity_id,
          start_time: this.filter_data.start_time,
          end_time: this.filter_data.end_time,
          page: this.pagination_data.current_page,
          per_page: this.pagination_data.per_page,
        })
        if (response.status === 200 && result.code === 0) {
          this.list = result.data
          this.pagination_data = result.meta
          // 调接口成功更改导出时间
          this.export_start_time = this.filter_data.start_time
          this.export_end_time = this.filter_data.end_time
        } else {
          this.$store.dispatch('showMessage', {
            type: 'failure',
            title: '获取模板活动员工数据统计失败',
            content: `${result.message}`,
          })
        }
      } catch (err) {
        this.$store.dispatch('showMessage', {
          type: 'failure',
          title: '获取模板活动员工数据统计失败',
          content: `错误：${err}`,
        })
      }
    },

    // 导出
    exportData () {
      this.exportActivityStatisticMember(`activity_id=${this.activity_id}&start_time=${this.export_start_time}&end_time=${this.export_end_time}`)
    },
  },
  watch: {
    'filter_data.range_time': function (newVal) {
      if (newVal !== '') {
        let start, end
        let date = newVal.split(' 至 ');
        [start, end] = [date[0].split('-'), date[1].split('-')]
        start[1] = --start[1]
        end[1] = --end[1]
        // 存储选择日期的时间戳（秒）
        this.filter_data.start_time = new Date(...start).getTime() / 1000
        this.filter_data.end_time = new Date(...end, 23, 59, 59).getTime() / 1000
      } else {
        if (this.date_type === 1 || this.date_type === 2) return // 如果时间是被today或thisMonth方法更改的不重置查询时间
        this.filter_data.start_time = ''
        this.filter_data.end_time = ''
      }
    },
  },
  mounted () {
    this.activity_id = this.$route.query.id
    if (this.$route.query.range_time && this.$route.query.start_time && this.$route.query.end_time) {
      this.filter_data.range_time = this.$route.query.range_time
      this.filter_data.start_time = this.$route.query.start_time
      this.filter_data.end_time = this.$route.query.end_time
    }
    console.log(this.$route.query)
    if (Number(this.$route.query.date_type) === 1) {
      // 今日
      this.today()
    } else if (Number(this.$route.query.date_type) === 2) {
      // 本月
      this.thisMonth()
    } else if (Number(this.$route.query.date_type) === 0) {
      // 搜索
      this.search()
    }
  },
}
</script>

<style lang="stylus" scoped>
@import '~@/stylus/mixins'
.section-layout
  height calc(100% - 56px)
.section-filter
  padding-left 70px
.nav-back-btn
  position absolute
  top 36px
  left 16px
  width 32px
  height 32px
  border-radius 100%
  background #CED3DC center no-repeat url('~@/assets/back.svg')
  background-size 16px
  box-shadow 0 2px 6px 0 rgba(0, 0, 0, 0.08)
  cursor pointer
  z-index 2
.content-top
  height 139px
.title-filter
  padding 25px 65px 10px
  background #e8e9eb
.field-group
  position relative
.time
  position absolute
  right 40px
  bottom 20px
  border-radius 3px
  border 1px solid #D9D9D9
  box-sizing border-box
.time .day, .time .month
  display inline-block
  width 78px
  height 28px
  line-height 28px
  text-align center
  font-size 14px
  border-radius 3px
  background #D9D9D9
  color #9A9B9A
  cursor pointer
.active
  color #121212 !important
  background #FFFFFF !important
</style>


// WEBPACK FOOTER //
// src/components/content/EmployeeData.vue